import React, { useState } from "react";
import "./LinkList.css";
import "./LinkButton.css";
import TwitchIcon from "../assets/twitch-logo-png-1879.png";

const links = [
  {
    id: 1,
    label: "Twitch! | Tu streamuję!",
    url: "https://www.twitch.tv/ftkubus_",
    icon: TwitchIcon,
  },
  {
    id: 2,
    label: "Discord | Konkursy o skiny!",
    url: "https://discord.gg/5dt3gCNE2A",
    icon: "https://cdn.prod.website-files.com/6257adef93867e50d84d30e2/636e0a6918e57475a843f59f_icon_clyde_black_RGB.svg",
    requiresDiscordHelp: true,
  },
  {
    id: 3,
    label: "Donejty | Tipply",
    url: "https://tipply.pl/@ftkubus",
    icon: "https://cdn-icons-png.flaticon.com/512/218/218409.png",
  },
  {
    id: 4,
    label: "YouTube",
    url: "https://youtube.com/@FTKubus",
    icon: "https://www.iconpacks.net/icons/1/free-youtube-icon-123-thumb.png",
  },
  {
    id: 5,
    label: "Instagram",
    url: "https://instagram.com/ftkubus_",
    icon: "https://icons.veryicon.com/png/o/miscellaneous/offerino-icons/instagram-53.png",
  },
  {
    id: 6,
    label: "TikTok",
    url: "https://tiktok.com/@ftkubus",
    icon: "https://www.svgrepo.com/show/447151/tiktok-outline.svg",
  },
];

export default function LinkListWithDiscordHelper() {
  const [show, setShow] = useState(false);
  const [inviteUrl, setInviteUrl] = useState("");

  function handleClick(link) {
    return (e) => {
      if (link.requiresDiscordHelp) {
        e.preventDefault();
        if (isTikTokBrowser()) {
          setInviteUrl(link.url);
          setShow(true);
        } else {
          window.open(link.url, "_blank");
        }
      }
    };
  }

  return (
    <div className="link-list">
      {links.map((link) => (
        <a
          key={link.id}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="link-button"
          onClick={handleClick(link)}
        >
          {link.icon && <img src={link.icon} alt="" className="link-icon" />}
          {link.label}
        </a>
      ))}

      {show && <DiscordTikTokHelper onClose={() => setShow(false)} inviteUrl={inviteUrl} />}
    </div>
  );
}

function isTikTokBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = (navigator.userAgent || navigator.vendor || "").toLowerCase();
  return ua.includes("tiktok") || ua.includes("musical.ly");
}

function DiscordTikTokHelper({ onClose, inviteUrl }) {
  const [copied, setCopied] = useState(false);

  async function copyInvite() {
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch {}
  }

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className="modal-card">
        <div className="modal-header">
          <h2>Jak dołączyć na Discord z TikToka</h2>
          <button onClick={onClose} className="close">✕</button>
        </div>
        <div className="modal-body">
          <p>TikTok otwiera linki w swojej przeglądarce, co blokuje otwarcie Discorda. Zrób tak:</p>
          <ol>
            <li><b>Dotknij ⋯</b> w prawym górnym rogu.</li>
            <li>Wybierz <b>„Otwórz w przeglądarce”</b>.</li>
            <li>Potwierdź <b>„Otwórz w aplikacji Discord”</b>.</li>
          </ol>
          <details>
            <summary>Alternatywa</summary>
            <ul>
              <li><b>Przytrzymaj</b> link i wybierz „Kopiuj”.</li>
              <li>Otwórz Safari/Chrome, wklej link.</li>
              <li>Potwierdź otworzenie linku na Discordzie!</li>
            </ul>
          </details>
          <div className="copy-row">
            <code>{inviteUrl}</code>
            <button onClick={copyInvite}>{copied ? "Skopiowano!" : "Kopiuj"}</button>
          </div>
          <small>Tip (Android): czasem działa przeciągnięcie w dół i kliknięcie ikony Chrome.</small>
        </div>
        <div className="modal-footer">
          <a href={inviteUrl} target="_blank" rel="noopener noreferrer" className="btn">Spróbuj otworzyć teraz</a>
          <button onClick={onClose} className="btn-primary">Gotowe</button>
        </div>
      </div>
    </div>
  );
}